import { useEffect, useRef, useState } from "react";
import globalClasses from "../../../commoncomponents/css/Global.module.css";
import CommonLayout from "../../../commoncomponents/layout/CommonLayout";
import ServiceDetails from "../servicedetails/ServiceDetails";
import { setSnackbar } from "../../../commoncomponents/alert/SnackbarAction";
import { setServiceData, setOrganizationData } from "../../RegistraionAction";
import { serviceNameRegex } from "../../../commoncomponents/input/Regex";
import { postAxios, singoutHandler } from "../../../../api/AxiosAPICall";
import { Backdrop, CircularProgress, Grid, Typography } from "@mui/material";
import * as Yup from "yup";
import { useFormik } from "formik";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation, useNavigationType } from "react-router-dom";
let registerClinic: any;

export let clinicDetailsObject = {
  clinicId: 0,
  clinicName: "",
  additionalServices: "",
  monday: [
    {
      startTime: "",
      endTime: "",
      setTimeAllWeek: false,
    },
  ],
  tuesday: [
    {
      startTime: "",
      endTime: "",
    },
  ],
  wednesday: [
    {
      startTime: "",
      endTime: "",
    },
  ],

  thursday: [
    {
      startTime: "",
      endTime: "",
    },
  ],

  friday: [
    {
      startTime: "",
      endTime: "",
    },
  ],
  saturday: [
    {
      startTime: "",
      endTime: "",
    },
  ],
  sunday: [
    {
      startTime: "",
      endTime: "",
    },
  ],
};

const ServiceComponent = () => {
  let history = useNavigate();
  const location = useLocation();
  const navType = useNavigationType();
  const [mode, setMode] = useState("");
  const [cliId, setCliId] = useState("");
  const [headerButton, setHeaderButton] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const isMounted = useRef<any>();
  let clinicNamesList: { [key: number]: string } = {};
  let jwtToken: any;
  const dispatch = useDispatch();
  const { organizationJson } = useSelector((state: any) => state.organization);

  if (localStorage.getItem("token") != null) {
    jwtToken = localStorage.getItem("token");
  }

  useEffect(() => {
    return () => {
      if (navType === "POP") {
        history("/unauthenticatedUser");
      }
    };
  }, [navType, history]);

  useEffect(() => {
    isMounted.current = true;
    if (location?.state?.mode !== undefined) {
      setMode(location.state.mode);
      setHeaderButton(true);
    } else {
      setHeaderButton(false);
    }
    return () => {
      isMounted.current = false;
      setMode("");
    };
  }, [location]);

  useEffect(() => {
    isMounted.current = true;
    if (location?.state?.mode !== "edit") {
      if (
        organizationJson === undefined ||
        organizationJson === "" ||
        organizationJson === null
      ) {
        history("/organization");
      }
    }
    return () => {
      isMounted.current = false;
    };
  }, [location, organizationJson, history]);

  useEffect(() => {
    window.addEventListener("beforeunload", alertUser);
    return () => {
      window.removeEventListener("beforeunload", alertUser);
    };
  }, []);

  const alertUser = (e: any) => {
    e.preventDefault();
    e.returnValue = "";
  };

  const getCliId = (cliId: any) => {
    setCliId(cliId);
  };

  const getClinicData = async (clinicDetailsJson: any) => {
    let finalClinicDetailssJson = { clinicDetails: clinicDetailsJson };

    setIsLoading(true);
    if (mode !== "edit" && organizationJson !== undefined) {
      registerClinic = { ...organizationJson, ...finalClinicDetailssJson };
      dispatch(setServiceData(registerClinic));
      dispatch(setOrganizationData(registerClinic));
      history("/servicetype");
      setIsLoading(false);
    }
  };

  let clinicDetails = {
    clinicName: Yup.string(),
    additionalServices: Yup.string()

      .max(8000, "Additional must be under 8000 characters.")
      .matches(
        serviceNameRegex,
        "Only Aplhabets ,numbers and this symbols !@#$%^&*(){}[]/|\\-',. are allowed."
      ),
    monday: Yup.array().of(
      Yup.object().shape({
        startTime: Yup.string()
          .nullable()
          .test("startTime", "startTime", (value: any, context: any) => {
            return true;
          }),
        endTime: Yup.string()
          .nullable()
          .test(
            "endTime",
            "End Time must be more than Start Time",
            (value: any, context: any) => {
              if (
                value !== undefined &&
                context.parent.startTime !== undefined &&
                context.parent.startTime !== null &&
                context.parent.endTime !== undefined &&
                context.parent.endTime !== null
              ) {
                return moment(value).isAfter(moment(context.parent.startTime));
              }
              return true;
            }
          ),
      })
    ),

    tuesday: Yup.array().of(
      Yup.object().shape({
        startTime: Yup.string()
          .nullable()
          .test("startTime", "startTime", (value: any, context: any) => {
            return true;
          }),
        endTime: Yup.string()
          .nullable()
          .test(
            "endTime",
            "End Time must be more than Start Time",
            (value: any, context: any) => {
              if (
                value !== undefined &&
                context.parent.startTime !== undefined &&
                context.parent.startTime !== null &&
                context.parent.endTime !== undefined &&
                context.parent.endTime !== null
              ) {
                return moment(value).isAfter(moment(context.parent.startTime));
              }
              return true;
            }
          ),
      })
    ),
    wednesday: Yup.array().of(
      Yup.object().shape({
        startTime: Yup.string()
          .nullable()
          .test("startTime", "startTime", (value: any, context: any) => {
            return true;
          }),
        endTime: Yup.string()
          .nullable()
          .test(
            "endTime",
            "End Time must be more than Start Time",
            (value: any, context: any) => {
              if (
                value !== undefined &&
                context.parent.startTime !== undefined &&
                context.parent.startTime !== null &&
                context.parent.endTime !== undefined &&
                context.parent.endTime !== null
              ) {
                return moment(value).isAfter(moment(context.parent.startTime));
              }
              return true;
            }
          ),
      })
    ),

    thursday: Yup.array().of(
      Yup.object().shape({
        startTime: Yup.string()
          .nullable()
          .test("startTime", "startTime", (value: any, context: any) => {
            return true;
          }),
        endTime: Yup.string()
          .nullable()
          .test(
            "endTime",
            "End Time must be more than Start Time",
            (value: any, context: any) => {
              if (
                value !== undefined &&
                context.parent.startTime !== undefined &&
                context.parent.startTime !== null &&
                context.parent.endTime !== undefined &&
                context.parent.endTime !== null
              ) {
                return moment(value).isAfter(moment(context.parent.startTime));
              }
              return true;
            }
          ),
      })
    ),

    friday: Yup.array().of(
      Yup.object().shape({
        startTime: Yup.string()
          .nullable()
          .test("startTime", "startTime", (value: any, context: any) => {
            return true;
          }),
        endTime: Yup.string()
          .nullable()
          .test(
            "endTime",
            "End Time must be more than Start Time",
            (value: any, context: any) => {
              if (
                value !== undefined &&
                context.parent.startTime !== undefined &&
                context.parent.startTime !== null &&
                context.parent.endTime !== undefined &&
                context.parent.endTime !== null
              ) {
                return moment(value).isAfter(moment(context.parent.startTime));
              }
              return true;
            }
          ),
      })
    ),

    saturday: Yup.array().of(
      Yup.object().shape({
        startTime: Yup.string()
          .nullable()
          .test("startTime", "startTime", (value: any, context: any) => {
            return true;
          }),
        endTime: Yup.string()
          .nullable()
          .test(
            "endTime",
            "End Time must be more than Start Time",
            (value: any, context: any) => {
              if (
                value !== undefined &&
                context.parent.startTime !== undefined &&
                context.parent.startTime !== null &&
                context.parent.endTime !== undefined &&
                context.parent.endTime !== null
              ) {
                return moment(value).isAfter(moment(context.parent.startTime));
              }
              return true;
            }
          ),
      })
    ),

    sunday: Yup.array().of(
      Yup.object().shape({
        startTime: Yup.string()
          .nullable()
          .test("startTime", "startTime", (value: any, context: any) => {
            return true;
          }),
        endTime: Yup.string()
          .nullable()
          .test(
            "endTime",
            "End Time must be more than Start Time",
            (value: any, context: any) => {
              if (
                value !== undefined &&
                context.parent.startTime !== undefined &&
                context.parent.startTime !== null &&
                context.parent.endTime !== undefined &&
                context.parent.endTime !== null
              ) {
                return moment(value).isAfter(moment(context.parent.startTime));
              }
              return true;
            }
          ),
      })
    ),
  };

  const formik = useFormik({
    initialValues: clinicDetailsObject,

    validationSchema: Yup.object(
      mode === "edit"
        ? clinicDetails
        : {
            clinicName: Yup.string()
              .max(30, "clinic name must be under 30 characters.")
              .default("")
              .required("Please enter clinic name")
              .matches(serviceNameRegex, "Please enter valid clinic name.")
              .test(
                "unique",
                "Cannot have two clinic with similar name, Please enter unique clinic name",
                async (value: any, context: any) => {
                  for (let key in clinicNamesList) {
                    let serviceContextPath = "serviceName";
                    if (serviceContextPath === context.path.toString()) {
                      continue;
                    }
                    if (
                      value !== "" &&
                      clinicNamesList[key] !== "" &&
                      value === clinicNamesList[key]
                    ) {
                      return false;
                    }
                  }
                  return true;
                }
              ),
            additionalServices: Yup.string()
              .max(8000, "Additional must be under 8000 characters.")
              .matches(
                serviceNameRegex,
                "Only Aplhabets ,numbers and this symbols !@#$%^&*(){}[]/|\\-',. are allowed."
              ),
            monday: Yup.array().of(
              Yup.object().shape({
                startTime: Yup.string()
                  .nullable()
                  .test("startTime", (value: any, context: any) => {
                    return context.parent.endTime || value !== undefined;
                  }),
                endTime: Yup.string()
                  .nullable()
                  .test(
                    "endTime",
                    "End Time must be more than Start Time",
                    (value: any, context: any) => {
                      if (
                        value !== undefined &&
                        context.parent.startTime !== undefined &&
                        context.parent.startTime !== null &&
                        context.parent.endTime !== undefined &&
                        context.parent.endTime !== null
                      ) {
                        return moment(value).isAfter(
                          moment(context.parent.startTime)
                        );
                      }
                      return true;
                    }
                  ),
              })
            ),
            tuesday: Yup.array().of(
              Yup.object().shape({
                startTime: Yup.string()
                  .nullable()
                  .test(
                    "startTime",
                    "startTime",
                    (value: any, context: any) => {
                      return true;
                    }
                  ),
                endTime: Yup.string()

                  .nullable()
                  .test(
                    "endTime",
                    "End Time must be more than Start Time",
                    (value: any, context: any) => {
                      if (
                        value !== undefined &&
                        context.parent.startTime !== undefined &&
                        context.parent.startTime !== null &&
                        context.parent.endTime !== undefined &&
                        context.parent.endTime !== null
                      ) {
                        return moment(value).isAfter(
                          moment(context.parent.startTime)
                        );
                      }
                      return true;
                    }
                  ),
              })
            ),
            wednesday: Yup.array().of(
              Yup.object().shape({
                startTime: Yup.string()

                  .nullable()
                  .test(
                    "startTime",
                    "startTime",
                    (value: any, context: any) => {
                      return true;
                    }
                  ),
                endTime: Yup.string()

                  .nullable()
                  .test(
                    "endTime",
                    "End Time must be more than Start Time",
                    (value: any, context: any) => {
                      if (
                        value !== undefined &&
                        context.parent.startTime !== undefined &&
                        context.parent.startTime !== null &&
                        context.parent.endTime !== undefined &&
                        context.parent.endTime !== null
                      ) {
                        return moment(value).isAfter(
                          moment(context.parent.startTime)
                        );
                      }
                      return true;
                    }
                  ),
              })
            ),

            thursday: Yup.array().of(
              Yup.object().shape({
                startTime: Yup.string()

                  .nullable()
                  .test(
                    "startTime",
                    "startTime",
                    (value: any, context: any) => {
                      return true;
                    }
                  ),
                endTime: Yup.string()

                  .nullable()
                  .test(
                    "endTime",
                    "End Time must be more than Start Time",
                    (value: any, context: any) => {
                      if (
                        value !== undefined &&
                        context.parent.startTime !== undefined &&
                        context.parent.startTime !== null &&
                        context.parent.endTime !== undefined &&
                        context.parent.endTime !== null
                      ) {
                        return moment(value).isAfter(
                          moment(context.parent.startTime)
                        );
                      }
                      return true;
                    }
                  ),
              })
            ),

            friday: Yup.array().of(
              Yup.object().shape({
                startTime: Yup.string()

                  .nullable()
                  .test(
                    "startTime",
                    "startTime",
                    (value: any, context: any) => {
                      return true;
                    }
                  ),
                endTime: Yup.string()

                  .nullable()
                  .test(
                    "endTime",
                    "End Time must be more than Start Time",
                    (value: any, context: any) => {
                      if (
                        value !== undefined &&
                        context.parent.startTime !== undefined &&
                        context.parent.startTime !== null &&
                        context.parent.endTime !== undefined &&
                        context.parent.endTime !== null
                      ) {
                        return moment(value).isAfter(
                          moment(context.parent.startTime)
                        );
                      }
                      return true;
                    }
                  ),
              })
            ),

            saturday: Yup.array().of(
              Yup.object().shape({
                startTime: Yup.string()

                  .nullable()
                  .test(
                    "startTime",
                    "startTime",
                    (value: any, context: any) => {
                      return true;
                    }
                  ),
                endTime: Yup.string()

                  .nullable()
                  .test(
                    "endTime",
                    "End Time must be more than Start Time",
                    (value: any, context: any) => {
                      if (
                        value !== undefined &&
                        context.parent.startTime !== undefined &&
                        context.parent.startTime !== null &&
                        context.parent.endTime !== undefined &&
                        context.parent.endTime !== null
                      ) {
                        return moment(value).isAfter(
                          moment(context.parent.startTime)
                        );
                      }
                      return true;
                    }
                  ),
              })
            ),

            sunday: Yup.array().of(
              Yup.object().shape({
                startTime: Yup.string()

                  .nullable()
                  .test(
                    "startTime",
                    "startTime",
                    (value: any, context: any) => {
                      return true;
                    }
                  ),
                endTime: Yup.string()

                  .nullable()
                  .test(
                    "endTime",
                    "End Time must be more than Start Time",
                    (value: any, context: any) => {
                      if (
                        value !== undefined &&
                        context.parent.startTime !== undefined &&
                        context.parent.startTime !== null &&
                        context.parent.endTime !== undefined &&
                        context.parent.endTime !== null
                      ) {
                        return moment(value).isAfter(
                          moment(context.parent.startTime)
                        );
                      }
                      return true;
                    }
                  ),
              })
            ),
          }
    ),
    onSubmit: async () => {
      if (mode === "edit") {
        setIsLoading(true);
        const response = await postAxios(
          "clinic",
          {
            cliId: cliId,
            cliName: formik.values.clinicName,
            cliAdditionalServices: formik.values.additionalServices,
            businessHoursJson: {
              cbhMondayStartTime:
                formik.values.monday[0].startTime === "" ||
                formik.values.monday[0].startTime === undefined ||
                formik.values.monday[0].startTime === null
                  ? ""
                  : moment(formik.values.monday[0].startTime).format("HH:mm") +
                    ":00",
              cbhMondayEndTime:
                formik.values.monday[0].endTime === "" ||
                formik.values.monday[0].endTime === undefined ||
                formik.values.monday[0].endTime === null
                  ? ""
                  : moment(formik.values.monday[0].endTime).format("HH:mm") +
                    ":00",
              cbhTuesdayStartTime:
                formik.values.tuesday[0].startTime === "" ||
                formik.values.tuesday[0].startTime === undefined ||
                formik.values.tuesday[0].startTime === null
                  ? ""
                  : moment(formik.values.tuesday[0].startTime).format("HH:mm") +
                    ":00",
              cbhTuesdayEndTime:
                formik.values.tuesday[0].endTime === "" ||
                formik.values.tuesday[0].endTime === undefined ||
                formik.values.tuesday[0].endTime === null
                  ? ""
                  : moment(formik.values.tuesday[0].endTime).format("HH:mm") +
                    ":00",
              cbhWednesdayStartTime:
                formik.values.wednesday[0].startTime === "" ||
                formik.values.wednesday[0].startTime === undefined ||
                formik.values.wednesday[0].startTime === null
                  ? ""
                  : moment(formik.values.wednesday[0].startTime).format(
                      "HH:mm"
                    ) + ":00",
              cbhWednesdayEndTime:
                formik.values.wednesday[0].endTime === "" ||
                formik.values.wednesday[0].endTime === undefined ||
                formik.values.wednesday[0].endTime === null
                  ? ""
                  : moment(formik.values.wednesday[0].endTime).format("HH:mm") +
                    ":00",
              cbhThursdayStartTime:
                formik.values.thursday[0].startTime === "" ||
                formik.values.thursday[0].startTime === undefined ||
                formik.values.thursday[0].startTime === null
                  ? ""
                  : moment(formik.values.thursday[0].startTime).format(
                      "HH:mm"
                    ) + ":00",
              cbhThursdayEndTime:
                formik.values.thursday[0].endTime === "" ||
                formik.values.thursday[0].endTime === undefined ||
                formik.values.thursday[0].endTime === null
                  ? ""
                  : moment(formik.values.thursday[0].endTime).format("HH:mm") +
                    ":00",
              cbhFridayStartTime:
                formik.values.friday[0].startTime === "" ||
                formik.values.friday[0].startTime === undefined ||
                formik.values.friday[0].startTime === null
                  ? ""
                  : moment(formik.values.friday[0].startTime).format("HH:mm") +
                    ":00",
              cbhFridayEndTime:
                formik.values.friday[0].endTime === "" ||
                formik.values.friday[0].endTime === undefined ||
                formik.values.friday[0].endTime === null
                  ? ""
                  : moment(formik.values.friday[0].endTime).format("HH:mm") +
                    ":00",
              cbhSaturdayStartTime:
                formik.values.saturday[0].startTime === "" ||
                formik.values.saturday[0].startTime === undefined ||
                formik.values.saturday[0].startTime === null
                  ? ""
                  : moment(formik.values.saturday[0].startTime).format(
                      "HH:mm"
                    ) + ":00",
              cbhSaturdayEndTime:
                formik.values.saturday[0].endTime === "" ||
                formik.values.saturday[0].endTime === undefined ||
                formik.values.saturday[0].endTime === null
                  ? ""
                  : moment(formik.values.saturday[0].endTime).format("HH:mm") +
                    ":00",
              cbhSundayStartTime:
                formik.values.sunday[0].startTime === "" ||
                formik.values.sunday[0].startTime === undefined ||
                formik.values.sunday[0].startTime === null
                  ? ""
                  : moment(formik.values.sunday[0].startTime).format("HH:mm") +
                    ":00",
              cbhSundayEndTime:
                formik.values.sunday[0].endTime === "" ||
                formik.values.sunday[0].endTime === undefined ||
                formik.values.sunday[0].endTime === null
                  ? ""
                  : moment(formik.values.sunday[0].endTime).format("HH:mm") +
                    ":00",
            },
          },
          {
            headers: {
              Authorization: `Bearer ${jwtToken}`,
            },
          }
        );

        if (response.toString() === "ERROR") {
          setIsLoading(false);
          dispatch(
            setSnackbar(
              true,
              undefined,
              "warning",
              "Cellmaflex has encounter an issue. Please contact administrator.",
              "top",
              "center"
            )
          );
        } else if (response.toString() !== "" && typeof response !== "object") {
          setIsLoading(false);
          dispatch(
            setSnackbar(
              true,
              undefined,
              "warning",
              response.toString(),
              "top",
              "center"
            )
          );
          if (mode === "edit") {
            singoutHandler(jwtToken);
            localStorage.removeItem("token");
            history("/signin");
          }
        } else if (
          response.data.clinicBusinessHoursUpdate === "true" &&
          response.data.clinicUpdate === "true"
        ) {
          setIsLoading(false);
          dispatch(
            setSnackbar(
              true,
              4000,
              "success",
              "Clinic details have been saved successfully!",
              "top",
              "center"
            )
          );
        }
      }
    },
  });
  return (
    <CommonLayout
      showHeaderNavigation={headerButton}
      isLogedIn={headerButton === false ? false : true}
    >
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          {mode !== "edit" && (
            <>
              <Typography variant="h1" className={globalClasses.pageTitle}>
                Register your Organization
              </Typography>
              <Typography
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  margin: "10px",
                  color: "#474747",
                  fontSize: "14px",
                }}
              >
                Step 1 to step 4 is mandatory in order to complete registration
              </Typography>
            </>
          )}
        </Grid>
      </Grid>

      <ServiceDetails
        mode={mode}
        formik={formik}
        sendCliId={getCliId}
        sendClinicData={getClinicData}
      />

      {mode !== "edit" && isLoading && (
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: 1500,
            display: "flex",
            flexDirection: "column",
          }}
          open
        >
          <Typography fontWeight="600" fontSize="20px">
            Adding Clinics...!
          </Typography>
          <CircularProgress color="primary" sx={{ margin: "20px" }} />
        </Backdrop>
      )}

      {mode === "edit" && isLoading && (
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: 1500,
            display: "flex",
            flexDirection: "column",
          }}
          open
        >
          <Typography fontWeight="600" fontSize="20px">
            Updating Clinic Information...!
          </Typography>
          <CircularProgress color="primary" sx={{ margin: "20px" }} />
        </Backdrop>
      )}
    </CommonLayout>
  );
};

export default ServiceComponent;
